function ensureHash(color_hex) {
    return color_hex.startsWith("#") ? color_hex : `#${color_hex}`;

}

export { ensureHash };